import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Badge} from 'reactstrap';
import AlertCircle from 'react-feather/dist/icons/alert-circle.js';
import Tooltip from 'rc-tooltip';

import conf from '../../../../conf.js';
import {getPercent} from '../../../../services/stepService.js';

export default class Labels extends PureComponent {
  static propTypes = {
    freelance: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    className: PropTypes.string
  };

  static defaultProps = {
    className: ''
  };

  render() {
    const {user, freelance} = this.props;
    const badges = [];
    const isGray = user?.gray;
    const hasEmail = user?.email;
    const isComplete = user?.complete;

    if (isGray && !hasEmail && user?.old_email) {
      return <Badge className={this.props.className} color="danger">Supprimé</Badge>;
    } else {
      if (!!user?.meeting && !isComplete) {
        badges.push({color: 'info', message: 'RDV planifié'});
      }

      if (!isComplete) {
        badges.push({color: 'secondary', message: `Non complet ${getPercent(user)}%`});
      }

      if (hasEmail && isGray) {
        badges.push({color: 'primary', message: 'Importé'});
      }

      if (user?.unreliable) {
        badges.push({color: 'danger', message: 'Douteux'});
      }

      if (freelance?.no_show) {
        badges.push({color: 'danger', message: 'No show'});
      }

      if (freelance?.cdi) {
        badges.push({color: 'warning', message: 'En CDI'});
      }

      if (user?.isProgessiActive) {
        badges.push({color: 'success', message: 'En mandat'});
      }

      if (freelance?.public) {
        badges.push({color: 'dark', message: 'Masqué'})
      }

      const hasNoWorkPermit = [conf.workPermits.noAuthorization.value, conf.workPermits.project.value].includes(
        freelance?.work_permit ?? conf.workPermits.noAuthorization.value
      );

      return (badges.length || hasNoWorkPermit) ?
        <div className={["d-flex justify-content-center align-items-center", this.props.className].join(' ')}>
          {badges.map((badge, index) => {
            return <Badge key={index} color={badge.color} className="mx-1">{badge.message}</Badge>
          })}
          {hasNoWorkPermit ?
            <Tooltip placement="bottom" overlay="Pas d'autorisation de travail">
              <AlertCircle fill="red" color="white"/>
            </Tooltip> : ''
          }
        </div> : '';
    }
  }
}
